import { render, staticRenderFns } from "./AlertActiveNoticeModal.vue?vue&type=template&id=260498b0&scoped=true&"
import script from "./AlertActiveNoticeModal.vue?vue&type=script&lang=js&"
export * from "./AlertActiveNoticeModal.vue?vue&type=script&lang=js&"
import style0 from "./AlertActiveNoticeModal.vue?vue&type=style&index=0&id=260498b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260498b0",
  null
  
)

export default component.exports